<template>
  <a style="display: inline-block" class="small" href="#" v-single-click="() => openModelViewModal()">
    <ficon type="external-link-alt" />
    <span v-if="referenceField">{{ id }} の</span>情報を確認</a
  >
</template>
<script lang="ts">
export default {
  props: {
    id: { required: true },
    modelName: { required: true },
    virtualModelName: { required: false, default: false },
    referenceField: { required: false, default: false },
  },
  methods: {
    async openModelViewModal() {
      try {
        await $core.$modals.openModelViewModal({
          id: this.id,
          modelName: this.modelName,
          virtualModelName: this.virtualModelName,
          referenceField: this.referenceField,
        })
      } catch (e) {
        console.error(e)
        $core.$toast.errorToast(`${this.id} のデータが見つかりませんでした。`)
      }
    },
  },
}
</script>
